<script lang="ts">
    import {ArrowKeyRight, Button, Card, Heading, Hr, Input, Label, Modal, Select, Textarea} from "flowbite-svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import TipTapEditor from "$lib/utils/TipTapEditor";
    import {post, put} from "$lib/api";
    import {globalToast} from "$lib/stores/toast";
    import {CheckCircleSolid} from "flowbite-svelte-icons";
    import {onMount, createEventDispatcher} from "svelte";
    import emailTemplateHandler from "$lib/utils/templating/emailTemplateHandler";
    import parseHandlebars from "$lib/utils/templating/parseHandlebars";
    import TipTapBubbleMenu from "$lib/components/TipTapBubbleMenu.svelte";
    import type {Editor} from "@tiptap/core";
    import {mailTemplateLevels} from "$lib/utils/tableHeaders/mailTemplates";
    import {writable} from "svelte/store";
    export let open = false;
    export let template = {
        id: null,
        subject:'',
        name: '',
        level: '',
        content: '',
        placeholders: <any>[]
    };
    let editor:Editor;

    let html = '';

    let previewParts: {type: string, content: string}[] = [];



    const dispatch = createEventDispatcher();
    const addPlaceholder = () => {
        template.placeholders = [...template.placeholders, {entity: '', property: ''}]
    }
    const submitTemplate = async () => {
        template.content = previewParts.map(part => part.content).join('');
        if (template.id) {
            await put('/email-templates/' + template.id, template)
            dispatch('template-update', template)
        } else {
            const res = await post('/email-templates', template)
            template.id = res.id
            dispatch('new-template', template)
            // templates = [...templates, template]
        }

        $globalToast.timed('E-Mail Vorlage gespeichert', 3000, CheckCircleSolid)
        open = false;

    }
    const formatters = [
        {value: undefined, name: 'Kein Formatierung'},
        {value: 'date', name: 'Datum'},
        {value: 'time', name: 'Uhrzeit'},
        {value: 'currency', name: 'Eurobetrag'},
        {value: 'matcher', name: 'Key/Value-Matcher'},
        {value: 'link', name: 'Link'},
    ];
    const entities = [{
        name: 'Employee',
        value: 'Employee',
        properties: [
            {value: 'identityCode', name: 'Verification Code'},
            {value: 'employeeNumber', name: 'Personalnummer'},
            {value: 'firstName', name: 'Vorname'},
            {value: 'lastName', name: 'Nachname'},
            {value: 'name', name: 'Voller Name'},
            {value: 'email', name: 'E-Mail'},
            {value: 'mobile', name: 'Mobilfunknummer'},
            {value: 'status', name: 'Status'},
            {value: 'uuid', name: 'Globale Identifikationsnummer'},
            {value: 'unit.name', name: 'Unit Name'},
            {value: 'unit.email', name: 'Unit Email'},
            {value: 'nationality', name: 'Nationalität'},
            {value: 'dateOfBirth', name: 'Geburtsdatum'},
        ],
    }, {
        name: 'Arbeitsvertrag',
        value: 'Contract',
        properties: [
            {value: 'hiredAs', name: 'Angestellt als'},
            {value: 'startDate', name: 'Beginn der Anstellung'},
            {value: 'endDate', name: 'Vertragsende'},
            {value: 'qualification.title', name: 'Qualification'},
            {value: 'workDaysPerWeek', name: 'Wochenarbeitstage'},
            {value: 'workHoursPerDay', name: 'Arbeitsstunden pro Tag'},
            {value: 'monthlyHours', name: 'Arbeitsstunden pro Monat'},
            {value: 'ptoDays', name: 'Urlaubstage'},
            {value: 'wagePerHour', name: 'Stundenvergütung'},
            {value: 'trialPeriodMonths', name: 'Probemonate'},
            {value: 'paymentOnAccount', name: 'Akonto'},
            {value: 'employeeSignatureLink', name: 'Signaturlink MA'},
            {value: 'contractType', name: 'VertragsArt'},
        ]
    }, {
        name: 'Unit',
        value: 'Unit',
        properties: [
            {value: 'name', name: 'Name'},
            {value: 'email', name: 'E-Mail'},
            {value: 'address.place', name: 'Ort'},
            {value: 'phoneNumber', name: 'Telefonnummer'},
        ]
    }, {
        name: 'Eingabefeld',
        value: 'Input',
        properties: [
            {value: 'text', name: 'Standard'},
            {value: 'date', name: 'Datum'},
        ]
    }]
    const asCopy = () => {
        template.id = null;
        submitTemplate();
    }
    const rerender = () => {
        const exp = /{{(var:)*([^:]*?)(:[^}]+)*}}/g;
        let v:RegExpExecArray|null;
        while ((v = exp.exec(template.content)) !== null) {
            if(!template.placeholders.find(x => x.templateProperty === v[2])){
                template.placeholders = [...template.placeholders, {entity: 'Input', templateProperty: v[2]}]
            }
        }

        if(editor){
            editor.destroy();
        }
        html = previewParts.map(part => {
            let string = '';
            if(part.type === 'render'){
                string = part.content
            } else {
                string = '<div class="format py-1" id="editor"></div>'
            }
            return string
        }).join('');
        setTimeout(() => {
            editor = TipTapEditor(document.querySelector('#editor') || undefined, (changedContent: string) => {
                previewParts.find(x => x.type === 'edit').content = changedContent
                previewParts = [...previewParts]
            })
        })

    }
    onMount(() =>{
        previewParts = emailTemplateHandler(template);
        rerender();
    })
</script>

<Modal size="xxl" title="E-Mail Vorlage bearbeiten" bind:open>
    <form on:submit={submitTemplate}>
        <div class="flex gap-3">
            <Label class="space-y-2 flex-1">
                <span>Name</span>
                <Input required bind:value={template.name}/>
            </Label>
            <Label class="space-y-2 flex-1">
                <span>Betreff</span>
                <Input required bind:value={template.subject}/>
            </Label>
            <Label class="space-y-2">
                <span>Verfügbarkeit</span>
                <Select required bind:value={template.level} items={mailTemplateLevels}/>
            </Label>
        </div>

        <div class="grid gap-3 grid-cols-2 mt-5">
            <div>
                {#each previewParts as part}
                    {@html part.content}
                {/each}
               <!-- <TipTapBubbleMenu editor={editor}/>
                <div>{@html html}</div>-->
            </div>
            <div class="grid gap-5">

                {#each previewParts as part}
                    <textarea on:change={() => previewParts = [...previewParts]} bind:value={part.content} ></textarea>
                {/each}
                <div>
                    <Button class="" size="sm" on:click={rerender}>apply</Button>
                </div>
            </div>

        </div>
        <Hr/>
        <div>
            <Heading tag="h3" class="text-neutral-600">Eingebettete Variablen</Heading>
            {#each template.placeholders as placeholder}
                <div class="grid gap-2 grid-cols-9 place-self-start text-neutral-600 items-center my-3">
                    <Card class="space-y-2 col-span-2">
                        <InfoBox title="Entity" bind:value={placeholder.entity} items={entities} type="select"/>
                        {#if placeholder.entity}
                            <InfoBox title="Property" bind:value={placeholder.entityProperty} on:change={() => placeholder.templateProperty = placeholder.entityProperty}
                                     items={entities.find(x => x.value === placeholder.entity)?.properties}
                                     type="select"/>
                        {/if}
                    </Card>
                    <ArrowKeyRight class="w-6 place-self-center"/>
                    <Card >
                        <InfoBox title="Default value" bind:value={placeholder.default}/>
                    </Card>
                    <ArrowKeyRight class="w-6 place-self-center"/>
                    <Card class="space-y-2 col-span-2">
                        <InfoBox title="Formatter" bind:value={placeholder.formatter} items={formatters}
                                type="select"/>
                        {#if placeholder.formatter === 'matcher' || placeholder.formatter === 'link'}
                            <Textarea bind:value={placeholder.matcher} placeholder="{placeholder.formatter === 'matcher' ? '\{\"key\": \"value\"\}' : 'https://example.com?url=\{\{value\}\}'}"/>
                        {/if}
                    </Card>
                    <ArrowKeyRight class="w-6 place-self-center"/>
                    <Card>
                        <InfoBox super_edit={writable(true)} title="In Template" bind:value={placeholder.templateProperty}>
                        </InfoBox>
                    </Card>
                </div>
            {/each}
            <div class="mt-5">
                <Button on:click={addPlaceholder}>Variable hinzufügen</Button>
            </div>


        </div>
        <Hr/>
        <div class="mt-5 flex gap-5 justify-end">
            <Button type="submit">Save</Button>
            {#if template.id}
                <Button type="button" color="alternative" on:click={asCopy}>Save as copy</Button>
            {/if}
        </div>
    </form>
</Modal>